<div class="note">
    <div>
        <mat-checkbox 
            class="c-sales-process-note"
            [checked]="note.hasBeenRead"
            (change)="onToggle()"

        >
            {{note.message}}
        </mat-checkbox>
    </div>
    <ul 
        *ngIf="note.examples?.length && !note.hasBeenRead"
        class="note__examples"
    >
        <li 
            *ngFor="let example of note.examples"
            class="note__examples-item"
        >
            {{example}}
        </li>
    </ul>
</div>